import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const TEMPLATE_TYPES = [
  { value: 'marketing', label: '营销推广' },
  { value: 'notice', label: '活动通知' },
  { value: 'reminder', label: '到期提醒' },
]

export default function SmsMarketing() {
  const [institutions, setInstitutions] = useState([])
  const [selectedInst, setSelectedInst] = useState('')
  const [phoneCount, setPhoneCount] = useState(0)
  const [content, setContent] = useState('')
  const [msgType, setMsgType] = useState('marketing')
  const [templates, setTemplates] = useState([])
  const [records, setRecords] = useState([])
  const [stats, setStats] = useState({ totalCount: 0, totalSent: 0, totalFailed: 0 })
  const [loading, setLoading] = useState(false)
  const [sending, setSending] = useState(false)
  const [sendResult, setSendResult] = useState(null)
  const [activeTab, setActiveTab] = useState('send')
  const [showTemplateModal, setShowTemplateModal] = useState(false)
  const [newTemplate, setNewTemplate] = useState({ name: '', content: '' })

  useEffect(() => {
    loadInstitutions()
    loadTemplates()
    loadRecords()
  }, [])

  useEffect(() => {
    if (!selectedInst) { setPhoneCount(0); return }
    fetch(`${API}/sms/marketing/phones?institutionId=${selectedInst}`)
      .then(r => r.json())
      .then(d => { if (d.success) setPhoneCount(d.count) })
      .catch(e => { console.error(e) })
  }, [selectedInst])

  const loadInstitutions = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API}/institutions`)
      const d = await res.json()
      if (d.success) setInstitutions(d.data || [])
    } catch {}
    setLoading(false)
  }

  const loadTemplates = async () => {
    try {
      const res = await fetch(`${API}/sms/templates?type=marketing`)
      const d = await res.json()
      if (d.success) setTemplates(d.data || [])
    } catch {}
  }

  const loadRecords = async () => {
    try {
      const res = await fetch(`${API}/sms/marketing/records?limit=50`)
      const d = await res.json()
      if (d.success) {
        setRecords(d.data || [])
        setStats(d.stats || {})
      }
    } catch {}
  }

  const handleSend = async () => {
    if (!selectedInst) { alert('请先选择机构'); return }
    if (!content.trim()) { alert('请输入短信内容'); return }
    if (content.length > 500) { alert('内容不能超过500字'); return }
    if (!confirm(`确认向${phoneCount}位家长发送短信？`)) return

    setSending(true)
    setSendResult(null)
    try {
      const res = await fetch(`${API}/sms/marketing/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ institutionId: selectedInst, content: content.trim(), type: msgType }),
      })
      const d = await res.json()
      setSendResult(d)
      if (d.success) {
        setContent('')
        loadRecords()
        alert(`发送完成：成功 ${d.data.sent} 条，失败 ${d.data.failed} 条`)
      } else {
        alert('发送失败：' + (d.error || '未知错误'))
      }
    } catch (e) {
      alert('发送失败')
    }
    setSending(false)
  }

  const handleSaveTemplate = async () => {
    if (!newTemplate.name || !newTemplate.content) { alert('请填写名称和内容'); return }
    try {
      const res = await fetch(`${API}/sms/templates`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...newTemplate, type: 'marketing' }),
      })
      const d = await res.json()
      if (d.success) {
        setShowTemplateModal(false)
        setNewTemplate({ name: '', content: '' })
        loadTemplates()
      }
    } catch {}
  }

  const handleDeleteTemplate = async (id) => {
    if (!confirm('确定删除该模板？')) return
    try {
      await fetch(`${API}/sms/templates/${id}`, { method: 'DELETE' })
      loadTemplates()
    } catch {}
  }

  const charCount = content.length
  const charColor = charCount > 450 ? '#ff4d4f' : charCount > 350 ? '#faad14' : '#52c41a'

  return (
    <div style={{ padding: 24, maxWidth: 1100 }}>
      <h2 style={{ fontSize: 20, marginBottom: 6 }}>📱 短信营销</h2>
      <p style={{ color: '#888', fontSize: 13, marginBottom: 20 }}>
        向机构家长批量发送营销/通知短信，计费按实际发送成功条数统计
      </p>

      {/* 统计概览 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        {[
          { label: '发送批次', value: stats.totalCount, icon: '📊', color: '#1890ff' },
          { label: '总发送条数', value: stats.totalSent, icon: '📨', color: '#52c41a' },
          { label: '发送失败', value: stats.totalFailed, icon: '❌', color: '#ff4d4f' },
          { label: '短信余额', value: '查看控制台', icon: '💰', color: '#fa8c16' },
        ].map(s => (
          <div key={s.label} style={{ background: '#fff', borderRadius: 8, padding: '16px 20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>{s.icon} {s.label}</div>
            <div style={{ fontSize: 24, fontWeight: 700, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Tab 切换 */}
      <div style={{ display: 'flex', gap: 0, borderBottom: '2px solid #f0f0f0', marginBottom: 24 }}>
        {[{ id: 'send', label: '✏️ 发送短信' }, { id: 'records', label: '📋 发送记录' }, { id: 'templates', label: '📝 常用模板' }].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: '10px 24px',
              border: 'none',
              borderBottom: activeTab === tab.id ? '2px solid #1890ff' : '2px solid transparent',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: 14,
              color: activeTab === tab.id ? '#1890ff' : '#888',
              fontWeight: activeTab === tab.id ? 600 : 400,
              marginBottom: -2,
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* 发送短信 */}
      {activeTab === 'send' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
          {/* 左侧：表单 */}
          <div>
            <div style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <h3 style={{ fontSize: 14, marginBottom: 16 }}>发送配置</h3>

              <div style={{ marginBottom: 16 }}>
                <label style={label}>选择机构 *</label>
                <select value={selectedInst} onChange={e => setSelectedInst(e.target.value)} style={{ ...input, cursor: 'pointer' }}>
                  <option value="">请选择机构</option>
                  {institutions.map(i => (
                    <option key={i.id} value={i.id}>{i.name}（{i.type || '机构'}{i.city ? ` · ${i.city}` : ''}）</option>
                  ))}
                </select>
                {selectedInst && phoneCount >= 0 && (
                  <div style={{ marginTop: 8, padding: '8px 12px', background: phoneCount > 0 ? '#e6f7e6' : '#fff7e6', borderRadius: 6, fontSize: 13 }}>
                    📱 将发送至 <strong style={{ color: phoneCount > 0 ? '#52C41A' : '#FAAD14' }}>{phoneCount}</strong> 位家长
                    {phoneCount === 0 && <span style={{ color: '#FAAD14' }}>（该机构暂无家长手机号）</span>}
                  </div>
                )}
              </div>

              <div style={{ marginBottom: 16 }}>
                <label style={label}>短信类型</label>
                <div style={{ display: 'flex', gap: 12 }}>
                  {TEMPLATE_TYPES.map(t => (
                    <label key={t.value} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
                      <input type="radio" name="msgType" value={t.value} checked={msgType === t.value} onChange={e => setMsgType(e.target.value)} />
                      {t.label}
                    </label>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: 16 }}>
                <label style={label}>
                  短信内容 *
                  <span style={{ float: 'right', fontSize: 12, fontWeight: 400, color: charColor }}>{charCount}/500</span>
                </label>
                <textarea
                  value={content}
                  onChange={e => setContent(e.target.value)}
                  placeholder="请输入短信内容，例如：亲爱的家长您好，孩子参与的活动即将开始，请提醒孩子准时参加。"
                  style={{ ...input, height: 140, resize: 'none', fontFamily: 'inherit', lineHeight: 1.6 }}
                />
                <div style={{ marginTop: 6, fontSize: 12, color: '#888' }}>每条短信最多500字，实际发送时按运营商规范拆分计费</div>
              </div>

              <button
                onClick={handleSend}
                disabled={sending || !selectedInst || !content.trim() || phoneCount === 0}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: sending || !selectedInst || !content.trim() || phoneCount === 0 ? '#d9d9d9' : '#1890ff',
                  color: '#fff', border: 'none', borderRadius: 6, fontSize: 15,
                  cursor: sending || !selectedInst || !content.trim() || phoneCount === 0 ? 'not-allowed' : 'pointer',
                }}
              >
                {sending ? '发送中...' : `📤 发送短信${selectedInst && phoneCount > 0 ? `（${phoneCount}条）` : ''}`}
              </button>

              {sendResult && !sendResult.success && (
                <div style={{ marginTop: 12, padding: '10px 14px', background: '#fff2f0', borderRadius: 6, fontSize: 13, color: '#ff4d4f' }}>
                  ❌ 发送失败：{sendResult.error}
                </div>
              )}
            </div>
          </div>

          {/* 右侧：模板+预览 */}
          <div>
            <div style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <h3 style={{ fontSize: 14, margin: 0 }}>快速模板</h3>
                <button onClick={() => setShowTemplateModal(true)} style={{ fontSize: 12, color: '#1890ff', background: 'none', border: 'none', cursor: 'pointer' }}>+ 新建模板</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {templates.length === 0 && (
                  <div style={{ textAlign: 'center', padding: 20, color: '#ccc', fontSize: 13 }}>暂无模板</div>
                )}
                {templates.map(t => (
                  <div key={t.id} onClick={() => setContent(t.content)} style={{
                    padding: '10px 14px',
                    background: content === t.content ? '#e6f7ff' : '#fafafa',
                    border: `1px solid ${content === t.content ? '#91d5ff' : '#f0f0f0'}`,
                    borderRadius: 6, cursor: 'pointer', transition: 'all 0.2s',
                  }}>
                    <div style={{ fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 4 }}>
                      {t.name}
                      <span style={{ float: 'right', fontSize: 11, color: '#ccc' }}>使用{t.use_count || 0}次</span>
                    </div>
                    <div style={{ fontSize: 12, color: '#888', lineHeight: 1.4 }}>{t.content}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <h3 style={{ fontSize: 14, marginBottom: 12 }}>📱 短信预览</h3>
              <div style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: '12px 16px', background: '#fafafa', fontSize: 13, color: '#333', lineHeight: 1.6, minHeight: 80 }}>
                {content || '短信内容将显示在这里...'}
              </div>
              <div style={{ marginTop: 8, fontSize: 12, color: '#ccc', textAlign: 'right' }}>【博小兔AI】</div>
            </div>
          </div>
        </div>
      )}

      {/* 发送记录 */}
      {activeTab === 'records' && (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ fontSize: 14, margin: 0 }}>发送记录</h3>
            <button onClick={loadRecords} style={{ fontSize: 12, color: '#1890ff', background: 'none', border: 'none', cursor: 'pointer' }}>🔄 刷新</button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                {['机构', '内容', '类型', '发送成功/失败', '时间', '操作'].map(h => (
                  <th key={h} style={{ ...th, textAlign: 'left' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {records.map(r => (
                <tr key={r.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{r.institution_name}</td>
                  <td style={{ ...td, maxWidth: 260 }}><div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 240 }}>{r.content}</div></td>
                  <td style={td}>
                    <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#e6f7e6', color: '#52C41A' }}>
                      {r.type === 'marketing' ? '营销' : r.type === 'notice' ? '通知' : '提醒'}
                    </span>
                  </td>
                  <td style={td}>
                    <span style={{ color: '#52C41A', fontWeight: 500 }}>{r.sent}</span>
                    <span style={{ color: '#ccc' }}>/{r.total}</span>
                    {r.failed > 0 && <span style={{ color: '#ff4d4f', marginLeft: 6 }}>❌{r.failed}</span>}
                  </td>
                  <td style={{ ...td, color: '#999', fontSize: 12 }}>{r.created_at ? r.created_at.substring(0, 16) : '-'}</td>
                  <td style={td}>
                    <button onClick={() => setContent(r.content)} style={{ fontSize: 12, color: '#1890ff', background: 'none', border: 'none', cursor: 'pointer' }}>复用</button>
                  </td>
                </tr>
              ))}
              {records.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: 'center', padding: 40, color: '#ccc' }}>暂无发送记录</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* 常用模板 */}
      {activeTab === 'templates' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
            <button onClick={() => setShowTemplateModal(true)} style={{ padding: '8px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>+ 新建模板</button>
          </div>
          <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  {['模板名称', '内容', '使用次数', '创建时间', '操作'].map(h => (
                    <th key={h} style={{ ...th, textAlign: 'left' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {templates.map(t => (
                  <tr key={t.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ ...td, fontWeight: 500 }}>{t.name}</td>
                    <td style={{ ...td, maxWidth: 400 }}><div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 380 }}>{t.content}</div></td>
                    <td style={{ ...td, color: '#888' }}>{t.use_count || 0}次</td>
                    <td style={{ ...td, color: '#999', fontSize: 12 }}>{t.created_at ? t.created_at.substring(0, 10) : '-'}</td>
                    <td style={td}>
                      <button onClick={() => { setContent(t.content); setActiveTab('send') }} style={{ fontSize: 12, color: '#1890ff', background: 'none', border: 'none', cursor: 'pointer', marginRight: 12 }}>使用</button>
                      <button onClick={() => handleDeleteTemplate(t.id)} style={{ fontSize: 12, color: '#ff4d4f', background: 'none', border: 'none', cursor: 'pointer' }}>删除</button>
                    </td>
                  </tr>
                ))}
                {templates.length === 0 && (
                  <tr><td colSpan={5} style={{ textAlign: 'center', padding: 40, color: '#ccc' }}>暂无模板，请新建</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* 新建模板弹窗 */}
      {showTemplateModal && (
        <div style={overlay} onClick={() => setShowTemplateModal(false)}>
          <div style={modalCard} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontSize: 16, marginBottom: 16 }}>新建短信模板</h3>
            <div style={{ marginBottom: 12 }}>
              <label style={label}>模板名称 *</label>
              <input value={newTemplate.name} onChange={e => setNewTemplate(p => ({ ...p, name: e.target.value }))} placeholder="例如：活动提醒" style={input} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={label}>模板内容 *</label>
              <textarea value={newTemplate.content} onChange={e => setNewTemplate(p => ({ ...p, content: e.target.value }))} placeholder="短信内容..." style={{ ...input, height: 100, resize: 'none' }} />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowTemplateModal(false)} style={{ padding: '8px 20px', background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
              <button onClick={handleSaveTemplate} style={{ padding: '8px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>保存模板</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const th = { padding: '12px 16px', fontSize: 13, color: '#666', fontWeight: 500 }
const td = { padding: '12px 16px', fontSize: 13 }
const label = { display: 'block', marginBottom: 6, fontSize: 13, color: '#666', fontWeight: 500 }
const input = { width: '100%', padding: '9px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13, boxSizing: 'border-box' }
const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modalCard = { background: '#fff', borderRadius: 12, padding: 24, width: 480, boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }
